import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$httpProvider',
  '$rootScopeProvider',
  '$sceDelegateProvider',
  'webApiSettings',
  function (
    runtimeConstant,
    $httpProvider,
    $rootScopeProvider,
    $sceDelegateProvider,
    webApiSettings
  ) {
    function configureHttpInterceptor($q) {
      return {
        response: function (response) {
          return response;
        },
        responseError: function (rejection) {
          // Ensure rejection contains a proper config object if missing
          if (!rejection.config) {
            rejection.config = {};
          }

          return $q.reject(rejection);
        },
      };
    }

    function run() {
      try {
        $httpProvider.interceptors.push('authInterceptorService');
        $httpProvider.interceptors.push(configureHttpInterceptor);

        // Set the digestTTL for $rootScope
        $rootScopeProvider.digestTtl(40);

        // Define the allowed resource URLs for $sce
        $sceDelegateProvider.resourceUrlWhitelist([
          'self',
          'blob:http://**',
          'blob:https://**',
          ...webApiSettings.urlWhitelist.split(',')
        ]);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
